import ReadingCount from './ReadingCount';

export default ReadingCount;
